module.exports = __webpack_public_path__ + "static/media/benefits8.81ae29fb.png";